import {
	ApiUtils,
	_axios
}from '@/api/apiUtil.js';
import constant from '@/util/constant.js';
const api = {
	list: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/exams/exams/list", params, successCallback, failCallback, exceptionCallback);
	},
	list2: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/exams/exams/list2", params, successCallback, failCallback, exceptionCallback);
	},
	save: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.postLoadingAjax(constant.serverUrl + "/exams/exams/save", params, successCallback, failCallback, exceptionCallback);
	},
	toUpdate: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/exams/exams/toUpdate", params, successCallback, failCallback, exceptionCallback);
	},
	update: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.putLoadingAjax(constant.serverUrl + "/exams/exams/update", params, successCallback, failCallback, exceptionCallback);
	},bukao: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.putLoadingAjax(constant.serverUrl + "/exams/exams/bukao", params, successCallback, failCallback, exceptionCallback);
	},
	remove: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.deleteLoadingAjax(constant.serverUrl + "/exams/exams/remove", params, successCallback, failCallback, exceptionCallback);
	},getexpContent: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/exams/exams/getexpContent", params, successCallback, failCallback, exceptionCallback);
	},
	selectQuestionContent: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/exams/exams/selectQuestionContent", params, successCallback, failCallback, exceptionCallback);
	},
	getOneAnswers: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/exams/answers/getOneAnswers", params, successCallback, failCallback, exceptionCallback);
	},findPaperByKid: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/exams/exams10/findPaperByKid", params, successCallback, failCallback, exceptionCallback);
	},
	selectHistory: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.postLoadingAjax(constant.serverUrl + "/exams/exams/selectname", params, successCallback, failCallback, exceptionCallback);
	},
	downloadWord: (params) => {
		ApiUtils.downloadingAjax(constant.serverUrl + "/exams/exampaper/getExampaperDoc", params, "线下考卷.doc");
	},//判题后更改统计表
	updateRptanswers: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.putLoadingAjax(constant.serverUrl + "/exams/rptAnswers/updateRptanswers", params, successCallback, failCallback, exceptionCallback);
	},
}

export default api;
